import React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useModals } from '@/shared/lib/modal-manager'

export function RenameScenario({
	children,
}: {
	scenarioId: string
	children: React.ReactNode
}) {
	const { t } = useTranslation()

	const { showModal } = useModals()
	const formContext = useFormContext()
	const handleRename = () =>
		showModal('GENERIC_RENAME_MODAL', {
			title: t('app.edit_scenario_name', {
				defaultValue: 'Edit scenario name',
			}),
			value: formContext?.getValues('name'),
			onChange: (value: string) =>
				formContext?.setValue('name', value, {
					shouldDirty: true,
				}),
		})

	return <Slot onClick={handleRename}>{children}</Slot>
}
